import * as types from './actionTypes';

export const changeResponsiveMode = (responsiveMode) => ({
    type: types.RESPONSIVE_MODE_CHANGE,
    responsiveMode,
});
